import { allowsOnlySinglePiece } from '@/lib/pricing/option-exclusions';
import type { PrintComExcludeRules } from '@/lib/printcom/printing-method-selection';

// Een proefexemplaar (Print.com `printingmethod=sample`: een los, onbedrukt
// stuk) bestaat alleen als 1 stuk. De prijstabel vroeg het toch op voor de
// gewone aantallen (colsjaal 10-100, pen 25-250, magneetdoos 25-2000) en elke
// cel faalde. Op 19-10-2026 bevestigd: pen-sample 1 stuk geprijsd, 25 niet.
// Sleeves kent het via een opgeslagen regel (sample x copies 2..2500); die
// herkennen we uit de regels zelf.

const SINGLE_PIECE_PRINTING_METHODS = new Set(['sample']);

export const SINGLE_PIECE_QUANTITY_POLICY = Object.freeze({
  minimum: 1,
  maximum: 1,
  values: [1],
  exact: true,
  singlePiece: true,
});

export function isSinglePieceQuantityPolicy(policy: unknown): boolean {
  return Boolean(policy && typeof policy === 'object' && (policy as { singlePiece?: unknown }).singlePiece === true);
}

export function singlePieceQuantityPolicy(
  configuration: Record<string, unknown>,
  specifications: { excludes?: PrintComExcludeRules; quantitySettings?: { values?: unknown[] }; printComQuantityPolicy?: { quantities?: unknown[] } } | null | undefined,
  copiesProperty = 'copies',
) {
  const method = String(configuration.printingmethod ?? configuration.printing_method ?? '');
  if (SINGLE_PIECE_PRINTING_METHODS.has(method)) return SINGLE_PIECE_QUANTITY_POLICY;
  const candidateQuantities = [
    ...(Array.isArray(specifications?.quantitySettings?.values) ? specifications!.quantitySettings!.values! : []),
    ...(Array.isArray(specifications?.printComQuantityPolicy?.quantities) ? specifications!.printComQuantityPolicy!.quantities! : []),
  ];
  const onlyOne = allowsOnlySinglePiece(
    specifications?.excludes,
    (property) => ({ value: configuration[property] }),
    { copiesProperty, candidateQuantities },
  );
  return onlyOne ? SINGLE_PIECE_QUANTITY_POLICY : null;
}
